angular.module('impactx.list').controller('ServerSideListCtrl', ServerSideListCtrl);
ServerSideListCtrl.$inject = [
    '$controller',
    '$scope',
    'dataGen',
    '$listCache',
    'ListPrintService',
    'selectedListItems',
    '$routeParams',
    '$redirect',
    '$route',
    'TranslationService',
    '$mdDialog',
    '$rootScope',
    '$q',
    'ToastService',
    'PaginationService',
    'ToolbarService',
    'BackService',
    'ListFilterService',
    'AppConfiguration',
    'LoadingDialogService',
    '$location'];

function ServerSideListCtrl($controller, $scope, dataGen, $listCache, ListPrintService, selectedListItems,
                            $routeParams, $redirect, $route, TranslationService, $mdDialog, $rootScope, $q,
                            ToastService, PaginationService, ToolbarService, BackService, ListFilterService,
                            AppConfiguration, LoadingDialogService, $location) {
    var ctrl = this;
    ctrl.request = {};
    $scope.showScrollTopButton = false;
    ctrl.rowsPerPage = PaginationService.getNumberOfLines($scope.metaData.id);
    var mainView;
    var defer = {};
    if ($routeParams.preSetId > 0) {
        $scope.isPreFiltered = true;
        $scope.resetPreSetFilterTrns = TranslationService.get("showAll");

        if (!$listCache.getWasPreFiltered($scope.metaData.id)) {
            $listCache.remove($scope.metaData.id);
        }
    }
    else {
        if ($listCache.getWasPreFiltered($scope.metaData.id)) {
            $listCache.removeWasPreFiltered($scope.metaData.id)
        }
    }
    if (!$scope.metaData.buttonDefinition)
    {
        $scope.metaData.buttonDefinition = [];
    }
    if (!$scope.metaData.filtersTemplate) {
        $scope.metaData.filtersTemplate = 'shared/list/templates/serverside/list.filters.server.tmpl.html';
    }

    angular.extend(this, $controller('ListCtrl', {$scope: $scope}));

    if (!$scope.metaData.params) {
        $scope.metaData.params = {};
    }

    ctrl.isInitialized = false;
    ctrl.buttonsInitialized = false;
    ctrl.pageSelected = false;
    ctrl.allPagesSelected = false;
    ctrl.requestInProgress = false;

    $scope.isServer = true;

    $scope.metaData.params.listConfig = {page: 1, rowsPerPage: ctrl.rowsPerPage};
    registerScrollTop();

    // Overwritten from super

    ctrl.saveFilters = function () {
        $listCache.putFilters($scope.metaData.id, $scope.metaData.params.listConfig.filterBlocks);
        //Maybe we should also cache 'deprecated Filter' ???
    };

    ctrl.saveLastVisitedPageIndex = function () {
        $listCache.putLastVisitedPage($scope.metaData.id, $scope.metaData.params.listConfig.page);
    };

    ctrl.saveSortColumn = function () {
        $listCache.putSortColumn($scope.metaData.id, $scope.metaData.params.listConfig.sortColumn);
    };

    $scope.$on("$destroy", function () {
        ctrl.saveFilters();
        ctrl.saveLastVisitedPageIndex();
        ctrl.saveSortColumn();
        PaginationService.rowCount = undefined;
        $listCache.putLastScrollPosition($scope.metaData.id, mainView.scrollTop());
        ToolbarService.hideListFilterToggle();
        ListFilterService.selectedFilter.amount = 0;
        ListFilterService.selectedFilter.entries = [];
    });

    $scope.$on('list:resetPageSelection', function () {
        ctrl.allPagesSelected = false;
        checkPageSelected();
    });

    ctrl.performAfterListRefreshAction = function (options) {
        if (options) {
            if (options.unselectRow) {
                selectedListItems.unselectRow(options.unselectRow, $scope.metaData.idColumn);
            }
            if (options.unselectRows) {
                selectedListItems.unselectAll(options.unselectRows, $scope.metaData.idColumn);
            }
            if (options.unselectRow || (options.unselectRows && options.unselectRows.length)) {
                checkPageSelected();
                ctrl.allPagesSelected = false;
                ToolbarService.recalcButtons();
            }
        }
    };

    $scope.metaData.refreshListData = function (options) {
        var promise = ctrl.refreshDataWithPossibleBlock();

        if (promise) {
            promise.then(function () {
                ctrl.performAfterListRefreshAction(options);
            });
        }
    };

    this.refreshDataForAutocomplete = function (selectedEntry, filter) {
        filter.selectedAutocompleteValue = selectedEntry;
        if ((selectedEntry && selectedEntry.id) || selectedEntry == null) {
            ctrl.refreshData(undefined);
        }
    };

    this.refreshDataForStringAutocomplete = function (selectedEntry, filter) {
        filter.selectedAutocompleteStringValue = selectedEntry;
        ctrl.refreshData(undefined);
    };

    ctrl.refreshList = function () {
        ctrl.refreshData().then(function () {
            ToastService.openStandardToast(TranslationService.get('listRefreshed'));
        })
    };

    ctrl.refreshListForced = function () {
        LoadingDialogService.start();
        ctrl.refreshData(undefined, true).then(function () {
            ToastService.openStandardToast(TranslationService.get('listRefreshed'));
            LoadingDialogService.stop();
        }, function () {
            LoadingDialogService.stop();
        })
    };

    ctrl.refreshDataWithPossibleBlock = function (filterBlocks) {
        if ($scope.metaData.noAutoRefresh) {
            LoadingDialogService.start();
        }
        return ctrl.refreshData(filterBlocks, true).then(function () {
            LoadingDialogService.stop();
        }, function () {
            LoadingDialogService.stop();
        })
    };

    function prepareMetaData(metaData, filterBlocks) {
        var listConfig = metaData.params.listConfig;
        if (metaData.id) {
            listConfig.listIdentifier = metaData.id;
        }
        else {
            console.log("no list id defined for list with " + JSON.stringify(metaData))
        }
        listConfig.listLink = $location.path();
        var persistentListFilters = impactX.isDefined($scope, 'data.config.persistentListFilters');
        if (persistentListFilters) {
            listConfig.persistentListFilters = persistentListFilters;
        }

        if (filterBlocks) {
            listConfig.filterBlocks = filterBlocks;
        }

        // special for boolean filters: instead of "false", use "null"
        angular.forEach(listConfig.filterBlocks, function (filterBlock) {
            angular.forEach(filterBlock.filterValues, function (filterValue) {
                if (filterValue.type === 1 && !filterValue.stringValue) {
                    filterValue.stringValue = null;
                }
            });
        });


        if (metaData.valuesInteger) {
            listConfig.valuesInteger = metaData.valuesInteger;
        }
        if (metaData.valuesString) {
            listConfig.valuesString = metaData.valuesString;
        }
        return listConfig;
    }

    // Overwritten from super
    this.refreshData = function (filterBlocks, forceRefresh) {
        if (impactX.isDefined($scope, "dialogData.$error.required.length") > 0) {
            var noRequestDefer = $q.defer();
            //normally i would like to reject it, but this would produce console error outputs
            noRequestDefer.resolve();
            return noRequestDefer.promise;
        }
        if (!ctrl.isInitialized) {
            $scope.metaData.params.listConfig.filterBlocks = $listCache.getFilters($scope.metaData.id);
            $scope.lastPageIndex = $listCache.getLastVisitedPage($scope.metaData.id);
            if ($scope.lastPageIndex) {
                $scope.metaData.params.listConfig.page = $scope.lastPageIndex;
            }
            else {
                $scope.metaData.params.listConfig.page = 1;
                $scope.lastPageIndex = 1;
            }
            ctrl.isInitialized = true;
            $scope.lastScrollPosition = $listCache.getLastScrollPosition($scope.metaData.id);
            var sortColumn = $listCache.getSortColumn($scope.metaData.id);
            if (sortColumn) {
                $scope.metaData.params.listConfig.sortColumn = sortColumn;
            }

            $scope.selectedTrns = TranslationService.get('selected');
            $scope.selectAllPagesTrns = TranslationService.get('selectAllPages');
            $scope.selectPageTrns = TranslationService.get('selectPage');
            $scope.deselectAllPagesTrns = TranslationService.get('deselectAllPages');
            $scope.deselectPageTrns = TranslationService.get('deselectPage');
            addToolbarButtons();
        }
        else {
            $scope.lastScrollPosition = undefined;
        }

        var listConfig = prepareMetaData($scope.metaData, filterBlocks);

        if ($scope.metaData.noAutoRefresh && !forceRefresh)
        {
            var noRequestDefer = $q.defer();
            //normally i would like to reject it, but this would produce console error outputs
            noRequestDefer.resolve();
            return noRequestDefer.promise;
        }
        if (defer.resolve) {
            defer.resolve();
            defer = $q.defer();
        }
        else {
            defer = $q.defer();
        }

        ctrl.request = dataGen.postAsForm($scope, $scope.metaData.params, $scope.metaData.endpoint, defer.promise, false).then(function () {
            var filterBlocks,
                printToken,
                filters,
                maxPage;

            filterBlocks = listConfig.filterBlocks;

            //filter value might be deleted from backend-> update the filter values.
            var currentFilterLength = 0;
            var backendFilterLength = 0;
            angular.forEach(listConfig.filterBlocks, function (filterBlock) {
                currentFilterLength = currentFilterLength + filterBlock.filterValues.length;
            });
            angular.forEach($scope.data.config.filterBlocks, function (filterBlock) {
                backendFilterLength = backendFilterLength + filterBlock.filterValues.length;
            });
            if (!filterBlocks || currentFilterLength > backendFilterLength) {
                listConfig.filterBlocks = $scope.data.config.filterBlocks;
            }
            else {
                if (listConfig.filterBlocks) {
                    for (var i = 0; i < listConfig.filterBlocks.length; i++) {
                        if (listConfig.filterBlocks[i].filterValues) {
                            for (var j = 0; j < listConfig.filterBlocks[i].filterValues.length; j++) {
                                listConfig.filterBlocks[i].filterValues[j].additionalDataArray = $scope.data.config.filterBlocks[i].filterValues[j].additionalDataArray
                            }
                        }
                    }
                }
                if (listConfig.filters) {
                    for (var i = 0; i < listConfig.filters.length; i++) {
                        listConfig.filters[i].additionalDataArray = $scope.data.config.filters[i].additionalDataArray
                    }
                }
            }
            //IOBL-780: Default for dates, otherwise problem in IE and Firefox,
            // because date-picker would set current by himself and label and date would overlay.
            // This only happens if stringValue == undefined, works as intended in all browsers with null,
            // so we don't need to set an actual date and loose the current list.
            angular.forEach(listConfig.filterBlocks, function (filterBlock) {
                angular.forEach(filterBlock.filterValues, function (filterValue) {
                    if (filterValue.type === 2 && !filterValue.stringValue) {
                        filterValue.stringValue = null;
                    }
                    // boolean filters are initialized with "null" and should never have value "false"
                    // since 'false' == true
                    if (filterValue.type === 1 && (filterValue.stringValue === 'false' || !filterValue.stringValue)) {
                        filterValue.stringValue = null;
                    }
                });
            });

            $scope.metaData.actions = $scope.data.actions;
            $scope.metaData.additionalFields = $scope.data.additionalFields;
            // provide the trns to the list-controller, why didn't we do this sooner?
            $scope.metaData.trns = $scope.trns;

            printToken = $scope.data.config.printToken;
            if (printToken) {
                listConfig.printToken = printToken;
            }

            filters = listConfig.filters;
            if (!filters) {
                listConfig.filters = $scope.data.config.filters;
            }

            if (!listConfig.deprecatedFilter) {
                listConfig.deprecatedFilter = $scope.data.config.deprecatedFilter;
            }

            ListFilterService.setSelectedFilterInfo(listConfig.filterBlocks);

            $scope.numberOfPages.num = $scope.data.rows.length ? Math.ceil($scope.data.rows.length / ctrl.rowsPerPage) : 0;
            maxPage = $scope.data.rows.length ? Math.ceil($scope.data.rows.length / ctrl.rowsPerPage) : 1;
            if (listConfig.page > maxPage) {
                listConfig.page = maxPage;
            }
            $scope.maxPageNumber = Math.ceil($scope.data.rowCount / ctrl.rowsPerPage);
            $scope.rowCollection.splice(0, $scope.rowCollection.length);
            $scope.displayCollection = $scope.data.rows;
            angular.forEach($scope.data.rows, function (value) {
                $scope.rowCollection.push(value);
            });

            checkPageSelected();
        }).then(initButtons, initButtons); // also init buttons on error

        return ctrl.request;
    };

    function initButtons() {
        if (!ctrl.buttonsInitialized) {
            $scope.trns.print = TranslationService.get('print');
            $scope.trns.printList = TranslationService.get('printList');
            if ($scope.metaData.buttonDefinition) {
                for (var i = 0; i < $scope.metaData.buttonDefinition.length; i++) {
                    if ($scope.metaData.buttonDefinition[i].type === 'validation') {
                        $scope.metaData.buttonDefinition[i].params.form = $scope.dialogData;
                        if ($scope.metaData.buttonDefinition[i].params.disableExpression &&
                            $scope.metaData.buttonDefinition[i].params.disableExpression.errorReference) {
                            $scope.metaData.buttonDefinition[i].params.disableExpression.error = impactX.isDefined($scope,
                                $scope.metaData.buttonDefinition[i].params.disableExpression.errorReference);
                        }
                    }
                }
            }
            ToolbarService.setButtons($scope.metaData.buttonDefinition, $scope.trns, $scope.data.additionalFields);

            $scope.currentPageIndex = $scope.metaData.params.listConfig.page;

            if ($scope.lastScrollPosition) {
                mainView.animate({
                    scrollTop: $scope.lastScrollPosition
                }, 200);
            }
            ListFilterService.open();
            ctrl.buttonsInitialized = true;
        }
    }

    ctrl.toPreviousPage = function () {
        BackService.back();
    };

    ctrl.showBackButton = function () {
        return !$scope.metaData.backFunction;
    };

    $scope.selectPage = function (page) {
        if (page < 1)
            $scope.metaData.params.listConfig.page = 1;
        else {
            $scope.metaData.params.listConfig.page = page;
        }
        $scope.lastPageIndex = $scope.metaData.params.listConfig.page;
    };

    ctrl.addFilterBlock = function () {
        var newFilterBlock = JSON.parse(JSON.stringify($scope.metaData.params.listConfig.filterBlocks[$scope.metaData.params.listConfig.filterBlocks.length - 1]));
        $scope.metaData.params.listConfig.filterBlocks.push(newFilterBlock);
    };

    ctrl.deleteFilterBlock = function (filterBlockIndex) {
        if ($scope.metaData.params.listConfig.filterBlocks.length > 1) {
            $scope.metaData.params.listConfig.filterBlocks.splice(filterBlockIndex, 1);
        }
        ctrl.refreshData();
    };

    ctrl.addFilterValue = function (newFilter, filterBlockIndex) {
        var copyFilter = {};

        angular.copy(newFilter, copyFilter);

        if (newFilter !== undefined && newFilter !== null) {
            copyFilter.operator = copyFilter.defaultOperator;
            var filterBlock = $scope.metaData.params.listConfig.filterBlocks[filterBlockIndex];
            if (!filterBlock) {
                filterBlock = $scope.metaData.params.listConfig.filterBlocks[$scope.metaData.params.listConfig.filterBlocks.length - 1]
            }
            filterBlock.filterValues.push(copyFilter);

            //IOBL-780: Default for dates, otherwise problem in IE and Firefox,
            // because date-picker would set current by himself and label and date would overlay.
            // This only happens if stringValue == undefined, works as intended in all browsers with null,
            // so we don't need to set an actual date and loose the current list.
            if (copyFilter.type === 2 && !copyFilter.stringValue) {
                copyFilter.stringValue = null;
            }
            // boolean filters are initialized with "null" not "false"
            // since 'false' == true
            if (copyFilter.type === 1 && (copyFilter.stringValue === 'false' || !copyFilter.stringValue)) {
                copyFilter.stringValue = null;
            }
        }
    };

    ctrl.deleteFilters = function () {
        $scope.metaData.params.listConfig.filterBlocks.length = 1;
        angular.forEach($scope.metaData.params.listConfig.filterBlocks, function (filterBlock) {
            angular.forEach(filterBlock.filterValues, function (value) {
                delete value.stringValue;
                delete value.selectedAutocompleteValue;
                delete value.selectedAutocompleteStringValue;
                angular.forEach(value.cboptions, function (opt) {
                    opt.selected = false;
                });
                if (value.datePickerModel) {
                    value.datePickerModel = {selectedTemplate: "", selectedTemplateName: ""};
                }
            });
        });
        $scope.metaData.params.listConfig.page = 1;
        ctrl.isInitialized = false;
        ctrl.refreshData();
    };

    ctrl.deleteFilter = function (filter, filterBlockIndex, filterIndex) {
        var filterValues, index = null;
        $scope.metaData.params.listConfig.page = $scope.lastPageIndex;

        if (filter.selectedAutocompleteValue) {
            filter.stringValue = null;
            filter.selectedAutocompleteValue = {};
        }
        else if (filter.selectedAutocompleteStringValue) {
            filter.stringValue = null;
            filter.selectedAutocompleteStringValue = {};
        }
        else if (filter.stringValue) {
            filter.stringValue = null;
            ctrl.refreshData();
        }
        else if (impactX.isDefined(filter, 'datePickerModel.dateStart')) {
            filter.datePickerModel.selectedTemplateName = "";
            delete filter.datePickerModel.dateStart;
            delete filter.datePickerModel.dateEnd;
            ctrl.refreshData();
        }
        else {
            if (filter.startOrBlock) {
                var followingFilter = $scope.metaData.params.listConfig.filterBlocks[filterBlockIndex].filterValues[filterIndex + 1];
                if (followingFilter.endOrBlock) {
                    followingFilter.endOrBlock = false;
                    followingFilter.isOrBlockFilter = false;
                }
                else {
                    followingFilter.startOrBlock = true;
                }
            }
            if (filter.endOrBlock) {
                var previousFilter = $scope.metaData.params.listConfig.filterBlocks[filterBlockIndex].filterValues[filterIndex - 1];
                if (previousFilter.startOrBlock) {
                    previousFilter.startOrBlock = false;
                    previousFilter.isOrBlockFilter = false;
                }
                else {
                    previousFilter.endOrBlock = true;
                }
            }
            var filterBlock = $scope.metaData.params.listConfig.filterBlocks[filterBlockIndex];
            filterValues = filterBlock.filterValues;
            angular.forEach(filterValues, function (value, key) {
                if (value == filter) {
                    index = key;
                }
            });
            if (index !== null) {
                if (filterValues.length > 1) {
                    filterValues.splice(index, 1);
                }
                else if ($scope.metaData.params.listConfig.filterBlocks.length > 1) {
                    $scope.metaData.params.listConfig.filterBlocks.splice(filterBlockIndex, 1);
                }
            }
            ctrl.refreshData();
        }
    };

    ctrl.isSelected = function (row) {
        return selectedListItems.isSelected(row, $scope.metaData.idColumn);
    };

    ctrl.hasHeader = function (columnIdentifier) {
        var hasHeader = false;
        angular.forEach($scope.data.headers, function (header) {
            if (header && header.columnIdentifier == columnIdentifier) {
                hasHeader = true;
            }
        });
        return hasHeader;
    };

    ctrl.isDeleted = function (row) {
        return (row && row.deleted);
    };

    ctrl.getCellDecoration = function (decorationName, row, defaultValue) {
        //try to access other controllers decoration method.
        if (impactX.isFunction($scope, 'metaData.custom.getCellDecoration')) {
            return $scope.metaData.custom.getCellDecoration(decorationName, row, defaultValue);
        }

        return defaultValue;
    };

    ctrl.printExcel = function () {
        ListPrintService.printExcel($scope.metaData.params.listConfig, $scope.metaData.excelParams ? $scope.metaData.excelParams : [], $scope.metaData.printEndpoint)
    };

    ctrl.sortServerSide = function (header) {
        if (impactX.isDefined($scope, "metaData.params.listConfig.sortColumn.column") === header.columnIdentifier) {
            if ($scope.metaData.params.listConfig.sortColumn.sortOrder === 1) {
                $scope.metaData.params.listConfig.sortColumn.sortOrder = -1;
            }
            else {
                $scope.metaData.params.listConfig.sortColumn = {column: null, sortOrder: 0};
            }
        }
        else {
            $scope.metaData.params.listConfig.sortColumn = {column: header.columnIdentifier, sortOrder: 1};
        }

        ctrl.refreshDataWithPossibleBlock();
    };

    function checkPageSelected() {
        if ($scope.displayCollection && $scope.displayCollection.length) {
            ctrl.pageSelected = !$scope.displayCollection.some(function (row) {
                return !selectedListItems.isSelected(row, $scope.metaData.idColumn);
            });
        }
    }

    ctrl.toggleSelect = function (row) {
        if (row) {
            selectedListItems.toggleRow(row, $scope.metaData.idColumn);
            checkPageSelected();
            ctrl.allPagesSelected = false;
            ToolbarService.recalcButtons();
        }
    };

    ctrl.toggleSelectPage = function () {
        if (ctrl.pageSelected) {
            selectedListItems.unselectAll($scope.displayCollection, $scope.metaData.idColumn);
        }
        else {
            selectedListItems.selectAll($scope.displayCollection, $scope.metaData.idColumn);
        }
        checkPageSelected();
        ctrl.allPagesSelected = false
        ToolbarService.recalcButtons();
    };

    ctrl.toggleSelectAllPages = function () {
        if (!ctrl.requestInProgress) {
            if (ctrl.allPagesSelected) {
                ctrl.unselectAll();
            }
            else {
                selectAll();
            }
        }
    }

    ctrl.unselectAll = function () {
        selectedListItems.clearSelectedItems();
        ctrl.pageSelected = false;
        ctrl.allPagesSelected = false;
        ToolbarService.recalcButtons();
    }

    function selectAll() {
        ctrl.requestInProgress = true;
        $scope.metaData.params.listConfig.allPages = true;
        prepareMetaData($scope.metaData);

        var resp = {};
        dataGen.postAsForm(resp, $scope.metaData.params, $scope.metaData.endpoint).then(function () {
            if (resp.data) {
                selectedListItems.selectAll(resp.data.rows, $scope.metaData.idColumn);
                ctrl.allPagesSelected = true;
                ctrl.pageSelected = true;
            }
            $scope.metaData.params.listConfig.allPages = false;
            ctrl.requestInProgress = false;
            ToolbarService.recalcButtons();
        })
    }

    ctrl.resetPreSetFilter = function () {
        $redirect.redirectTo(null, $route.current.$$route.originalPath.replace("/:preSetId?", ""));
    };

    if ($scope.isPreFiltered && !$listCache.getWasPreFiltered($scope.metaData.id)) {
        $listCache.setWasPreFiltered($scope.metaData.id);
        $scope.showSearch = false;

        if (TranslationService.isInitialized()) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title(TranslationService.get("pleaseNote"))
                    .textContent(TranslationService.get("filteredWarning"))
                    .ariaLabel(TranslationService.get("filteredWarning"))
                    .ok(TranslationService.get("ok"))
                    .parent(angular.element(document.body))
            );
        }
    }

    this.addInternalOrFilter = function (filter, filterBlockIndex, filterIndex) {
        var newFilter = JSON.parse(JSON.stringify(filter));
        newFilter.$$hashKey = undefined;
        newFilter.endOrBlock = false;
        newFilter.startOrBlock = false;
        $scope.metaData.params.listConfig.filterBlocks[filterBlockIndex].filterValues.splice(filterIndex + 1, 0, newFilter);
        if (!filter.isOrBlockFilter) {
            filter.startOrBlock = true;
            newFilter.endOrBlock = true;
        }
        else {
            if (filter.endOrBlock) {
                filter.endOrBlock = false;
                newFilter.endOrBlock = true;
            }
        }
        filter.isOrBlockFilter = true;
        newFilter.isOrBlockFilter = true;
    };

    ctrl.onPageChange = function (pageNumber) {
        $scope.currentPageIndex = pageNumber;
        $scope.selectPage(pageNumber);
        return ctrl.refreshDataWithPossibleBlock();
    };

    ctrl.scrollToTop = function () {
        mainView.animate({
            scrollTop: 0
        }, 200);
    };

    function registerScrollTop() {
        mainView = angular.element(".ix-list-content");
        mainView.bind("scroll", function (event) {
            var target = angular.element(event.target);
            if (target) {
                var listContainer = angular.element('md-list');
                $scope.showScrollTopButton = listContainer.offset().top < target.offset().top;
            }
        });
    }

    ctrl.hasSelectedItems = function () {
        return $scope.getNumberOfSelectedItems() > 0;
    };

    ctrl.selectedItemsLabel = function () {
        return $scope.getNumberOfSelectedItems() + ' ' + $scope.selectedTrns;
    };

    ctrl.selectAllPagesLabel = function () {
        return $scope.selectAllPagesTrns;
    }

    function addToolbarButtons() {
        if ($scope.metaData.buttonDefinition) {
            if (!$scope.metaData.hidePrint) {
                $scope.metaData.buttonDefinition.unshift({
                    label: "printList",
                    action: ctrl.printExcel,
                    condition: function () {
                        return selectedListItems.isNoSelection();
                    }
                });
            }

            $scope.metaData.buttonDefinition.unshift({
                icon: 'mdi-close',
                labelFunction: ctrl.selectedItemsLabel,
                action: ctrl.unselectAll,
                condition: ctrl.hasSelectedItems
            });
        }

        if (!$scope.metaData.noAutoRefresh)
        {
            ToolbarService.showRefreshButton(ctrl.refreshList);
        }
        ToolbarService.showListFilterToggle();
        if (!$scope.metaData.hidePersistentListFilters) {
            ToolbarService.showPersistentListFilter();
        }
    }

    ctrl.getItemExpansionEntryPoint = function (row) {
        var itemExpansion = $scope.metaData.itemExpansion;
        if (itemExpansion.entryPoint) {
            return itemExpansion.entryPoint;
        }
        if (itemExpansion.entryPointFunction && typeof itemExpansion.entryPointFunction === 'function') {
            return itemExpansion.entryPointFunction(row);
        }
    }

    ctrl.getItemExpansionTemplate = function (row) {
        var itemExpansion = $scope.metaData.itemExpansion;
        if (itemExpansion.templateUrl) {
            return itemExpansion.templateUrl;
        }
        if (itemExpansion.templateUrlFunction && typeof itemExpansion.templateUrlFunction === 'function') {
            return itemExpansion.templateUrlFunction(row);
        }
    }

    ctrl.getItemExpansionParams = function (row) {
        var itemExpansion = $scope.metaData.itemExpansion;
        if (itemExpansion.paramsFunction && typeof itemExpansion.paramsFunction === 'function') {
            return itemExpansion.paramsFunction(row);
        }
    }

    ctrl.canExpand = function (row) {
        var itemExpansion = $scope.metaData.itemExpansion;
        if (AppConfiguration.get('showTooltipOverview') && itemExpansion) {
            if (itemExpansion.canExpandFunction && typeof itemExpansion.canExpandFunction === 'function') {
                return itemExpansion.canExpandFunction(row);
            }
            return true;
        }
    }

    var expandedRow;
    ctrl.toggleExpand = function (row) {
        if (row.isExpanded) {
            row.isExpanded = false;
            expandedRow = null;
        }
        else {
            if (expandedRow) {
                expandedRow.isExpanded = false;
            }
            row.isExpanded = true;
            expandedRow = row;
        }
    }
}
